const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

/**
 * Normalizes an entity id from a plain string or OData-style `{ _value: guid }` wrapper.
 * Returns a trimmed lowercase string for route segments and comparisons, or '' if missing.
 */
export function normalizeEntityId(id: unknown): string {
    let raw = '';
    if (typeof id === 'string') {
        raw = id;
    } else if (id && typeof id === 'object' && '_value' in (id as Record<string, unknown>)) {
        raw = (id as { _value?: string })._value ?? '';
    }
    const trimmed = raw.trim();
    return trimmed.length > 0 ? trimmed.toLowerCase() : '';
}

/** Returns true when {@link normalizeEntityId} yields a GUID-shaped string. */
export function isEntityId(id: unknown): boolean {
    return GUID_PATTERN.test(normalizeEntityId(id));
}

/** Minimal shape accepted by {@link resolveClientId} (full snapshot or invoice party expand). */
type ClientIdSource = { clientId?: string | null } | null | undefined;

/**
 * Live client id from a client snapshot (or fallback). Never use snapshot `id` for navigation/API refs.
 */
export function resolveClientId(snapshot: ClientIdSource, fallbackId?: unknown): string {
    return normalizeEntityId(snapshot?.clientId) || normalizeEntityId(fallbackId);
}
